// src/components/padrekko/qc/QcBackToCases.jsx
//
// "‹ Cases": leave the open QC case and return the panel to the cases list.
//
// IT LIVES IN THE PANEL HEADER (PadRekkoPanel), NOT THE CASE BAR. It changes
// what the PANEL shows, from the inspector or summary back to the list, so it
// is panel navigation, for the same reason "Back to summary" stays in the
// panel. The case bar above the map is case context plus stage transitions.
// The header is shrink-0 above the scroll body, so this is always on screen
// and is the first thing focus reaches in the panel.
//
// Labelled by destination: clearSession ends the case view and PadRekko then
// shows its cases list. "Back" would say nothing about where, and after a deep
// link there is no "previous". It is the ONLY way out of a case view: the ✕
// that QcInspector's run header and QcSummary's header each carried is gone.
//
// Renders null with no session: there is no case to leave.

import { ChevronLeft } from "lucide-react";
import { useQcStore } from "../../../stores/useQcStore";

export default function QcBackToCases() {
  const session      = useQcStore((s) => s.session);
  const clearSession = useQcStore((s) => s.clearSession);
  if (!session) return null;
  return (
    <button
      type="button"
      onClick={clearSession}
      className="flex items-center gap-0.5 shrink-0 text-[12px] px-2 py-1 rounded
                 border border-slate-700/70 bg-slate-800/60 text-slate-200
                 hover:text-white hover:bg-slate-700/70 hover:border-slate-600 transition"
      title="Close this case and return to the cases list"
      aria-label="Back to cases"
      data-qc-exit
    >
      <ChevronLeft size={14} />
      Cases
    </button>
  );
}
